import React from 'react'

const AccessDenied = () => {
  return (
    <div>AccessDenied</div>
  )
}

export default AccessDenied